import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search-contacts',
  templateUrl: './search-contacts.component.html',
  styleUrls: ['./search-contacts.component.scss']
})
export class SearchContactsComponent implements OnInit {

  options = ['asd', 'asdsds', 'vxcvx'];

  constructor() { }

  ngOnInit() {
  }

}
